import { message } from "antd";
import { SESSION_CONSTANT } from "./SessionConstants";
import { ONBOARDING_CONSTANT } from "./CommonConstants";

// Called on every logout path: drops the onboarding flag and the stored selection, and tells the
// in-memory context to forget the selection too.
export const resetSessionState = (): void => {
  try {
    sessionStorage.removeItem(SESSION_CONSTANT.ONBOARDING_KEY);
    sessionStorage.removeItem(SESSION_CONSTANT.PARTNERSHIP_CONTEXT_KEY);
  } catch {
    message.error(ONBOARDING_CONSTANT.CLEAR_FAILED_MESSAGE);
  }
  window.dispatchEvent(new Event(ONBOARDING_CONSTANT.SESSION_RESET_EVENT));
};

export const onSessionReset = (callback: () => void): void => {
  window.addEventListener(ONBOARDING_CONSTANT.SESSION_RESET_EVENT, callback);
};

export const offSessionReset = (callback: () => void): void => {
  window.removeEventListener(ONBOARDING_CONSTANT.SESSION_RESET_EVENT, callback);
};
